
<app-basic-card>
    <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
        <h6>Dati dell'assicurato:</h6>
    </div>
    <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
</app-basic-card>
<div class="mt-4" *ngIf="additionalForm">
    <app-basic-card>
        <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
            <h6>Dati del dichiarante:</h6>
        </div>
        <app-basic-form [form]="additionalForm" [keys]="additionalFormKeys"></app-basic-form>
    </app-basic-card>
</div>